import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { MergeFCService } from '../../../services/raintree/Transmission/merge-fc.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AreYouUpdatedService } from '../../../services/raintree/Transmission/are-you-updated.service';
import { LoaderComponent } from '../../../common-component/loader/loader.component';

@Component({
  selector: 'app-add-id-details-dialog',
  standalone: true,
  imports: [
    MatIconModule,
    MatDialogModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    LoaderComponent,
  ],
  templateUrl: './add-id-details-dialog.component.html',
  styleUrl: './add-id-details-dialog.component.scss',
})
export class AddIdDetailsDialogComponent {
  selectedFile: any;
  fileName: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toaster: ToastrService,
    private mergeFCService: MergeFCService,
    private dialogRef: MatDialogRef<AddIdDetailsDialogComponent>,
    private dialog: MatDialog,
    private areYouUpdatedService: AreYouUpdatedService
  ) {
    console.log('data', data);
  }
  isLoading: boolean = false;
  comment = new FormControl('');
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  mergedFcCount: number = 0;
  count: number = 0;
  typeList: string[] = ['AADHAAR CARD', 'PAN CARD'];
  idValue = new FormControl(
    this.data.rowData.docNo ? this.data.rowData.docNo : ''
  );
  contactNo = new FormControl('');
  selectedIdType = new FormControl(
    this.data.rowData.docType ? this.data.rowData.docType : ''
  );
  govtName = new FormControl('');
  ngOnInit() {
    console.log('DATA', this.data);
    this.selectedIdType.valueChanges.subscribe((type) => {
      if (type === 'PAN CARD') {
        this.selectedFile = null;
        this.fileName = '';
        this.idValue.patchValue(
          this.data.rowData.panSubmitted ? this.data.rowData.panNo : ''
        );
        this.idValue.setValidators([
          Validators.required,
          Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i),
        ]);
      } else if (type === 'AADHAAR CARD') {
        this.selectedFile = null;
        this.fileName = '';
        this.idValue.patchValue(
          this.data.rowData.adharSubmitted ? this.data.rowData.adharNo : ''
        );
        this.idValue.setValidators([
          Validators.required,
          Validators.pattern(/^\d{12}$/),
        ]);
      } else {
        this.idValue.patchValue('');
        this.idValue.clearValidators();
        this.selectedFile = null;
        this.fileName = '';
      }
      this.idValue.updateValueAndValidity();
    });
  }
  idTypeSelect(typeSelected: any) {
    console.log('Selected Type', typeSelected);
  }
  onFileSelected(event: any) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.selectedFile = file;
      const dotIndex = file.name.lastIndexOf('.');
      const namePart =
        dotIndex !== -1 ? file.name.substring(0, dotIndex) : file.name;
      const extPart = dotIndex !== -1 ? file.name.substring(dotIndex) : '';

      const shortName =
        namePart.length > 15 ? namePart.substring(0, 15) + '...' : namePart;
      this.fileName = shortName + extPart;
    }
  }
  saveAndUpload() {
    console.log(this.idValue, 'id value');
    const aadhaarNo = this.data.rowData.adharNo ? this.data.rowData.adharNo : null;
    const panNo = this.data.rowData.panNo ? this.data.rowData.panNo : null;
    if (this.selectedIdType.value == 'PAN CARD' && !panNo) {
      if (!this.idValue || this.idValue.invalid) {
        this.toaster.error('Fill all required fields');
        return;
      }
    } else if (this.selectedIdType.value == 'AADHAAR CARD' && !aadhaarNo) {
      if (!this.idValue || this.idValue.invalid) {
        this.toaster.error('Fill all required fields');
        return;
      }
    }

    //photo selection not mandatory
    // if (!this.selectedFile) {
    //   console.error('No file selected');
    //   this.toaster.error('No file selected');
    //   return;
    // }
    this.isLoading = true;
    const payloadObj = {
      memKey: this.data.rowData.mk ? this.data.rowData.mk : '',
      philMemCode: this.data.rowData.mc ? this.data.rowData.mc : '',
      philFamilyCode: this.data.rowData.fc ? this.data.rowData.fc : '',
      memPanNo:
        this.selectedIdType.value == 'PAN CARD' ? this.idValue.value : '',
      memAadharNo:
        this.selectedIdType.value == 'AADHAAR CARD' ? this.idValue.value : '',
      memContactNo: '',
    };

    const payloadStr = JSON.stringify(payloadObj);

    const formData = new FormData();
    formData.append(
      'emc',
      this.data.rowData.emc ? this.data.rowData.emc : ''
    );
    formData.append(
      'efc',
      this.data.rowData.efc ? this.data.rowData.efc : ''
    );
    formData.append(
      'philMemCode',
      this.data.rowData.mc ? this.data.rowData.mc : ''
    );
    formData.append(
      'philFamilyCode',
      this.data.rowData.fc ? this.data.rowData.fc : ''
    );
    formData.append('memKey', this.data.rowData.mk ? this.data.rowData.mk : '');
    formData.append(
      'memStateName',
      this.data.rowData.st ? this.data.rowData.st : ''
    );
    formData.append(
      'memPanNo',
      this.selectedIdType.value == 'PAN CARD'
        ? this.idValue.value.toUpperCase()
        : ''
    );
    formData.append(
      'memAadharNo',
      this.selectedIdType.value == 'AADHAAR CARD' ? this.idValue.value : ''
    );
    formData.append(
      'memGovName',
      this.selectedIdType.value == 'AADHAAR CARD' ||
        this.selectedIdType.value == 'PAN CARD'
        ? String(this.govtName.value)
        : ''
    );
    formData.append(
      this.selectedIdType.value == 'PAN CARD'
        ? 'memPanImage'
        : this.selectedIdType.value == 'AADHAAR CARD'
          ? 'memAadharImage'
          : 'image',
      this.selectedFile
    );

    if (
      this.data.rowData.docUploaded == 'No' &&
      this.data.rowData.docSubmitted == 'No'
    ) {
      this.areYouUpdatedService.saveIdDetails(formData).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this.dialogRef.close(true);
            this.toaster.success('Details Saved successfully');
          }
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
    } else {
      const formDataNew = new FormData();
      formDataNew.append(
        'emc',
        this.data.rowData.emc ? this.data.rowData.emc : ''
      );
      formDataNew.append(
        'memCode',
        this.data.rowData.mc ? this.data.rowData.mc : ''
      );
      // formDataNew.append('philFamilyCode', this.data.rowData.fc?this.data.rowData.fc:'');
      // formDataNew.append('memKey', this.data.rowData.mk ?this.data.rowData.mk:'');
      // formDataNew.append('memStateCode', this.data.rowData.stateCode?this.data.rowData.stateCode:'');

      if (this.selectedIdType.value == 'PAN CARD' && this.idValue?.dirty)
        formDataNew.append(
          'memPanNo',
          this.selectedIdType.value == 'PAN CARD'
            ? this.idValue.value.toUpperCase()
            : ''
        );

      if (this.selectedIdType.value == 'AADHAAR CARD' && this.idValue?.dirty)
        formDataNew.append(
          'memAadharNo',
          this.selectedIdType.value == 'AADHAAR CARD' ? this.idValue.value : ''
        );

      formDataNew.append(
        'memGovName',
        this.selectedIdType.value == 'AADHAAR CARD' ||
          this.selectedIdType.value == 'PAN CARD'
          ? String(this.govtName.value)
          : ''
      );
      formDataNew.append(
        this.selectedIdType.value == 'PAN CARD'
          ? 'memPanImg'
          : this.selectedIdType.value == 'AADHAAR CARD'
            ? 'memAadharImg'
            : 'image',
        this.selectedFile
      );

      if (this.data.rowData.mk && this.data.rowData.st) {
        formDataNew.append('memKey', this.data.rowData.mk);
        formDataNew.append('memStateName', this.data.rowData.st);
      }


      this.areYouUpdatedService.editIdDetails(formDataNew).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this.isLoading = false;
            this.dialogRef.close(true);
            this.toaster.success('Details updated successfully');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
    }
  }
  deleteFile() {
    this.selectedFile = null;
    this.fileName = '';
  }
}
